"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Loading = _interopRequireDefault(require("../Loading"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var WithLoading = function WithLoading(shouldLoad, text, className, size, thickness, textClassName) {
  return function (WrappedComponent) {
    return function PropsProxy(props) {
      return shouldLoad(props) ? _react["default"].createElement(_Loading["default"], {
        text: text,
        className: className,
        thickness: thickness,
        size: size,
        textClassName: textClassName
      }) // eslint-disable-line react/prop-types
      : _react["default"].createElement(WrappedComponent, props);
    };
  };
};

var _default = WithLoading;
exports["default"] = _default;